export default {
    methods: {
        $_getEmployeeEmailSignature(loggedInEmployee) {
            return `<p>Kind Regards, ${loggedInEmployee.fullName}</p>`;
        },
        $_mapEmployeeToEmailRecipientModel(employee) {
            return { id: employee.id, name: employee.fullName, email: employee.email };
        }
    }
}